import * as React from 'react';

import _ from 'underscore';

import {TextField} from './textfield';
import type {TextFieldProps} from './textfield';

type Props = TextFieldProps & {
    value: string;
    onChange: (newVal: string) => void;
    onBlur?: () => void;
    delay?: number;
    min?: number;
    max?: number;
};

export function TextFieldDebounced(props: Props) {
    const {value: propValue, onChange, onBlur, delay = 200, min, max, ...restProps} = props;

    const [value, setValue] = React.useState<string>(propValue);

    const onChangeRef = React.useRef(onChange);
    onChangeRef.current = onChange;

    const debouncedRef = React.useRef<
        | {
              cancel: () => void;
              (...args: any[]): void;
          }
        | null
        | undefined
    >(_.debounce((val: string) => onChangeRef.current(val), delay));

    React.useEffect(() => {
        setValue(propValue);
    }, [propValue]);

    const handleChange = React.useCallback((newValue: string) => {
        setValue(newValue);
        if (debouncedRef.current) {
            debouncedRef.current(newValue);
        }
    }, []);

    return (
        <TextField
            {...restProps}
            value={value}
            onChange={handleChange}
            // @ts-expect-error - TextField accepts onBlur at runtime but it's not in TextFieldProps
            onBlur={onBlur}
            min={min !== undefined ? String(min) : undefined}
            max={max !== undefined ? String(max) : undefined}
        />
    );
}
